import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogProps,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    makeStyles,
    Text,
} from '@fluentui/react-components';
import { NoteRegular } from '@fluentui/react-icons';
import { Note } from '../../../../data/types';
import { Column, Row } from '../../../common';
import { useCommonStyles } from '../../../common/Styles/commonStyles';
import { NoteControl } from '../../../controls/NoteControl';
import { useDialogControls } from '../../../dialogs/useDialogControls';

const useStyles = makeStyles({
    root: {
        maxWidth: '500px',
        maxHeight: '800px',
    },
    body: {},
});

export type CaseTaskNotesDialogProps = Partial<Omit<DialogProps, 'open' | 'onOpenChange'>> & {
    children?: JSX.Element;
    notes?: Note[];
    open?: boolean;
    onOpenChange?: (isOpen: boolean) => void;
    title?: string;
};

export const CaseTaskNotesDialog = (props: CaseTaskNotesDialogProps) => {
    const { children, notes, open = false, onOpenChange, title = 'Task Notes' } = props;

    const commonStyles = useCommonStyles();
    const styles = useStyles();

    const [dialogOpen, onOpenChangeHandler, closeDialog] = useDialogControls(open, onOpenChange);

    const onClickClose = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        closeDialog();
    };

    return (
        <Dialog modalType='modal' open={dialogOpen} onOpenChange={onOpenChangeHandler}>
            <DialogTrigger disableButtonEnhancement>{children}</DialogTrigger>
            <DialogSurface className={styles.root} style={{ minWidth: '700px' }}>
                <DialogBody className={styles.body}>
                    <DialogTitle>
                        <Column gap='small'>
                            <Row gap='small'>
                                <Column width='auto' vAlign='middle'>
                                    <NoteRegular />
                                </Column>
                                <Column>
                                    <Text size={300}>Selected Notes</Text>
                                </Column>
                            </Row>
                            <Text size={500} weight='semibold'>
                                {title}
                            </Text>
                        </Column>
                    </DialogTitle>
                    <DialogContent style={{ maxHeight: '500px' }}>
                        <Column maxHeight='500px' scroll gap='small' padding='pr-2'>
                            {(notes || []).map((note, index) => (
                                <NoteControl key={note.noteId} note={note} />
                            ))}
                            {!notes?.length && <Text>No notes to display.</Text>}
                        </Column>
                    </DialogContent>
                    <DialogActions>
                        <Button className={commonStyles.button.root} appearance='secondary' onClick={onClickClose}>
                            Close
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
